import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Construction } from 'lucide-react';

export default function ComingSoonPage({ role = 'partner', onLogout }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    if (onLogout) onLogout();
    navigate('/select-role', { replace: true });
  };

  const roleLabel = {
    staff: 'Staff',
    host: 'Host',
    admin: 'Admin',
  };

  return (
    <div
      className="app-shell"
      style={{
        minHeight: '100vh',
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'var(--app-bg)',
        padding: '0 32px',
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}
      >
        {/* Logo */}
        <img
          src="/allure-logo.png"
          alt="Allure"
          style={{ width: 90, height: 80, objectFit: 'contain', marginBottom: 24 }}
        />

        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            backgroundColor: 'var(--accent-surface)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 20,
            boxShadow: 'var(--premium-shadow-nested)',
          }}
        >
          <Construction size={28} color="var(--accent-purple)" />
        </div>

        <h1
          style={{
            fontFamily: "'Amarante', serif",
            fontSize: 26,
            fontWeight: 400,
            color: '#303030',
            marginBottom: 8,
          }}
        >
          {roleLabel[role] || 'Partner'} App
        </h1>

        <p
          style={{
            fontFamily: "'Inria Serif', serif",
            fontSize: 16,
            color: '#666666',
            lineHeight: 1.5,
            marginBottom: 32,
          }}
        >
          The {roleLabel[role]?.toLowerCase() || 'partner'} experience is coming soon. We're building something amazing for you!
        </p>

        <button
          onClick={handleLogout}
          style={{
            width: 200,
            padding: '12px 0',
            fontFamily: "'Inria Serif', serif",
            fontSize: 18,
            fontWeight: 400,
            color: '#000000',
            background: 'rgba(251, 249, 255, 0.25)',
            border: 'none',
            borderRadius: 9999,
            cursor: 'pointer',
            boxShadow: '0px 3px 4.5px 0px #703FF6',
            outline: '2px solid rgba(251, 249, 255, 0.6)',
            outlineOffset: '-1px',
          }}
        >
          Go Back
        </button>
      </motion.div>
    </div>
  );
}
